// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"PWL_LRv5","bubble":"K2Hr7hdR"};